import { jsx as t, jsxs as I, Fragment as W } from "react/jsx-runtime";
import { AlertGroup as tn, Alert as nn, AlertVariant as Be, AlertActionCloseButton as rn, Page as an, Modal as vt, ModalVariant as ln, TextContent as sn, Text as Ie, Button as B, Spinner as Ct, FormHelperText as We, HelperText as ze, HelperTextItem as Je, Popover as on, Icon as _e, FormGroup as It, NumberInput as cn, ValidatedOptions as j, InputGroup as xe, InputGroupItem as qe, TextInput as Te, Select as Ee, SelectList as Ae, SelectOption as Ye, MenuToggle as se, MenuToggleStatus as Qe, TextInputGroup as kt, TextInputGroupMain as wt, ChipGroup as Xe, Chip as Ze, TextInputGroupUtilities as St, Switch as dn, TextArea as xt, FileUpload as un, Title as hn, Card as pn, CardHeader as mn, CardTitle as fn, CardBody as gn, Grid as yn, GridItem as ot, PageSection as bn, JumpLinks as vn, JumpLinksItem as Cn, ButtonVariant as we, Checkbox as In, Radio as kn, MenuFooter as wn, Dropdown as Tt, DropdownList as Et, DropdownItem as Me, Masthead as Sn, MastheadToggle as xn, PageToggleButton as Tn, MastheadBrand as En, MastheadContent as An, Toolbar as ke, ToolbarContent as $e, ToolbarItem as H, Avatar as Rn, Bullseye as Dn, EmptyState as On, EmptyStateIcon as ct, EmptyStateHeader as Fn, EmptyStateBody as Pn, EmptyStateFooter as Vn, EmptyStateActions as Mn, SearchInput as Ln, Divider as Nn, Pagination as Bn, Badge as _n } from "@patternfly/react-core";
import { createContext as At, useContext as Rt, useRef as Y, useEffect as oe, useCallback as pe, useState as A, useMemo as U, forwardRef as qn, useId as Dt, Fragment as Ot, Children as Ft, Component as $n, isValidElement as Un } from "react";
import { useTranslation as $ } from "react-i18next";
import { NetworkError as Pt } from "@keycloak/keycloak-admin-client";
import Kn from "keycloak-js";
import { ExclamationCircleIcon as Hn, ExclamationTriangleIcon as jn, HelpIcon as Gn, EyeIcon as Wn, EyeSlashIcon as zn, TimesIcon as Vt, CubeIcon as Jn, PaypalIcon as Yn, InstagramIcon as Qn, BitbucketIcon as Xn, MicrosoftIcon as Zn, TwitterIcon as er, StackOverflowIcon as tr, OpenshiftIcon as nr, LinkedinIcon as rr, GoogleIcon as ar, GitlabIcon as lr, FacebookSquareIcon as ir, GithubIcon as sr, MinusCircleIcon as or, PlusCircleIcon as Mt, EllipsisVIcon as cr, BarsIcon as dr, ThIcon as ur, SearchIcon as hr, SyncAltIcon as pr } from "@patternfly/react-icons";
import { useFormContext as Re, Controller as ce, useController as De, FormProvider as mr, useWatch as fr } from "react-hook-form";
import { get as q, intersectionBy as gr, cloneDeep as yr } from "lodash-es";
import "@cpelements/rh-site-switcher";
import ve from "@patternfly/react-styles/css/components/Avatar/avatar";
import { css as br } from "@patternfly/react-styles";
import { Table as vr, TableVariant as Cr, Thead as Ir, Tr as Ce, Th as Le, Tbody as dt, Td as le, ExpandableRowContent as kr, ActionsColumn as wr, TableText as Sr } from "@patternfly/react-table";
import './main.css';function et(e, n) {
  const r = At(n);
  return r.displayName = e, r;
}
const xr = ["error", "errorMessage"], Ne = "error_description";
function Tr(e) {
  if (typeof e == "string")
    return e;
  if (e instanceof Pt)
    return Lt(e.responseData);
  if (e instanceof Error)
    return e.message;
  throw new Error("Unable to determine error message.");
}
function Er(e) {
  if (!(e instanceof Pt))
    return;
  const n = e.responseData;
  return Ar(n);
}
function Ar(e) {
  if (typeof e == "object" && e !== null && Ne in e && typeof e[Ne] == "string")
    return e[Ne];
}
function Lt(e) {
  if (!(typeof e != "object" || e === null))
    for (const n of xr) {
      const r = e[n];
      if (typeof r == "string")
        return r;
    }
}
const Rr = () => Math.floor(Math.random() * 1e3);
function Dr(e) {
  return e != null;
}
function tt(e) {
  const n = Rt(e);
  if (Dr(n))
    return n;
  throw new Error(
    `No provider found for ${e.displayName ? `the '${e.displayName}'` : "an unknown"} context, make sure it is included in your component hierarchy.`
  );
}
function Or() {
  const e = Y(!1), n = Y(/* @__PURE__ */ new Set());
  oe(() => (e.current = !1, () => {
    e.current = !0, r();
  }), []);
  function r() {
    n.current.forEach((a) => clearTimeout(a)), n.current.clear();
  }
  return pe((a, l) => {
    if (e.current)
      throw new Error("Can't schedule a timeout on an unmounted component.");
    const i = Number(setTimeout(s, l));
    n.current.add(i);
    function s() {
      n.current.delete(i), a();
    }
    return function() {
      clearTimeout(i), n.current.delete(i);
    };
  }, []);
}
function Fr({ alerts: e, onCloseAlert: n }) {
  return /* @__PURE__ */ t(
    tn,
    {
      "data-testid": "global-alerts",
      isToast: !0,
      style: { whiteSpace: "pre-wrap" },
      children: e.map(({ id: r, variant: a, message: l, description: i }, s) => /* @__PURE__ */ t(
        nn,
        {
          "data-testid": s === 0 ? "last-alert" : void 0,
          isLiveRegion: !0,
          variant: Be[a],
          component: "p",
          variantLabel: "",
          title: l,
          actionClose: /* @__PURE__ */ t(
            rn,
            {
              title: l,
              onClose: () => n(r)
            }
          ),
          children: i && /* @__PURE__ */ t("p", { children: i })
        },
        r
      ))
    }
  );
}
const Pr = 8e3, Nt = et(
  "AlertContext",
  void 0
), Ua = () => tt(Nt), Vr = ({ children: e }) => {
  const { t: n } = $(), r = Or(), [a, l] = A([]), i = (c) => l((u) => u.filter((d) => d.id !== c)), s = pe(
    (c, u = Be.success, d) => {
      const g = {
        id: Rr(),
        message: c,
        variant: u,
        description: d
      };
      l((y) => [g, ...y]), r(() => i(g.id), Pr);
    },
    [r]
  ), o = pe(
    (c, u) => {
      const d = n(c, { error: Tr(u) }), g = Er(u);
      s(d, Be.danger, g);
    },
    [s, n]
  ), h = U(() => ({ addAlert: s, addError: o }), [s, o]);
  return /* @__PURE__ */ I(Nt.Provider, { value: h, children: [
    /* @__PURE__ */ t(Fr, { alerts: a, onCloseAlert: i }),
    e
  ] });
}, Mr = (e) => {
  const { t: n, i18n: r } = $(), a = e.error, l = Lr(a), i = Lt(a);
  console.error(a);
  function s() {
    location.href = location.origin + location.pathname;
  }
  return /* @__PURE__ */ t(an, { children: /* @__PURE__ */ t(
    vt,
    {
      variant: ln.small,
      title: n("somethingWentWrong"),
      titleIconVariant: "danger",
      showClose: !1,
      isOpen: !0,
      actions: [
        /* @__PURE__ */ t(B, { variant: "primary", onClick: s, children: n("tryAgain") }, "tryAgain")
      ],
      children: /* @__PURE__ */ t(sn, { children: l ? /* @__PURE__ */ t(Ie, { children: n(l) }) : i && r.exists(i) ? /* @__PURE__ */ t(Ie, { children: n(i) }) : /* @__PURE__ */ t(Ie, { children: n("somethingWentWrongDescription") }) })
    }
  ) });
};
function Lr(e) {
  return e instanceof Error ? e.message : null;
}
function Nr(e, n, r) {
  const [a, l] = A(
    () => e.getItem(n) ?? r
  ), i = pe((s) => {
    l(s), e.setItem(n, s);
  }, []);
  return oe(() => {
    l(e.getItem(n) ?? r), window.addEventListener("storage", s);
    function s(o) {
      o.storageArea === e && (o.key === null || o.key === n) && l(o.newValue ?? r);
    }
    return () => window.removeEventListener("storage", s);
  }, [e, n]), [a, i];
}
function Bt(e, n, r) {
  const a = U(
    () => JSON.stringify(r),
    [r]
  ), [l, i] = Nr(
    e,
    n,
    a
  ), s = U(() => JSON.parse(l), [l]), o = pe(
    (h) => i(JSON.stringify(h)),
    []
  );
  return [s, o];
}
const _t = et(
  "HelpContext",
  void 0
), Br = () => tt(_t), _r = ({ children: e }) => {
  const [n, r] = Bt(localStorage, "helpEnabled", !0);
  function a() {
    r(!n);
  }
  return /* @__PURE__ */ t(_t.Provider, { value: { enabled: n, toggleHelp: a }, children: e });
}, qr = () => At(void 0);
let Ue;
const Ka = () => {
  const e = Rt(Ue);
  if (!e)
    throw Error(
      "no environment provider in the hierarchy make sure to add the provider"
    );
  return e;
}, Ha = ({
  environment: e,
  keycloak: n,
  children: r
}) => {
  Ue = qr();
  const a = Y(!1), [l, i] = A(!!n), [s, o] = A(), h = U(() => {
    if (n)
      return n;
    const c = new Kn({
      url: e.serverBaseUrl,
      realm: e.realm,
      clientId: e.clientId
    });
    return c.onAuthLogout = () => c.login(), c;
  }, [e, n]);
  return oe(() => {
    if (n || a.current)
      return;
    h.init({
      onLoad: "login-required",
      pkceMethod: "S256",
      responseMode: "query",
      scope: e.scope
    }).then(() => i(!0)).catch((u) => o(u)), a.current = !0;
  }, [h, n]), s ? /* @__PURE__ */ t(Mr, { error: s }) : l ? /* @__PURE__ */ t(Ue.Provider, { value: { environment: e, keycloak: h }, children: /* @__PURE__ */ t(Vr, { children: /* @__PURE__ */ t(_r, { children: r }) }) }) : /* @__PURE__ */ t(Ct, {});
};
function ja() {
  const n = document.getElementById("environment")?.textContent;
  if (typeof n != "string")
    throw new Error("Environment variables not found in the document.");
  try {
    return JSON.parse(n);
  } catch {
    throw new Error("Unable to parse environment variables as JSON.");
  }
}
const Ga = ({
  modalTitle: e,
  continueLabel: n,
  cancelLabel: r,
  buttonTitle: a,
  isDisabled: l,
  buttonVariant: i,
  buttonTestRole: s,
  onContinue: o,
  component: h = B,
  children: c,
  ...u
}) => {
  const [d, g] = A(!1);
  return /* @__PURE__ */ I(W, { children: [
    /* @__PURE__ */ t(
      h,
      {
        variant: i,
        onClick: () => g(!0),
        isDisabled: l,
        "data-testrole": s,
        children: a
      }
    ),
    /* @__PURE__ */ t(
      vt,
      {
        variant: "small",
        ...u,
        title: e,
        isOpen: d,
        onClose: () => g(!1),
        actions: [
          /* @__PURE__ */ t(
            B,
            {
              id: "modal-confirm",
              variant: "primary",
              onClick: () => {
                g(!1), o();
              },
              children: n
            },
            "confirm"
          ),
          /* @__PURE__ */ t(
            B,
            {
              id: "modal-cancel",
              variant: "secondary",
              onClick: () => g(!1),
              children: r
            },
            "cancel"
          )
        ],
        children: c
      }
    )
  ] });
}, qt = ({ message: e, ...n }) => /* @__PURE__ */ t(We, { ...n, children: /* @__PURE__ */ t(ze, { children: /* @__PURE__ */ t(Je, { icon: /* @__PURE__ */ t(Hn, {}), variant: "error", children: e }) }) }), $t = ({
  helpText: e,
  fieldLabelId: n,
  noVerticalAlign: r = !0,
  unWrap: a = !1,
  isRecommendation: l = !1
}) => {
  const { enabled: i } = Br(), s = l ? jn : Gn;
  return i ? /* @__PURE__ */ t(on, { bodyContent: e, children: /* @__PURE__ */ I(W, { children: [
    !a && /* @__PURE__ */ t(
      "button",
      {
        "data-testid": `help-label-${n}`,
        "aria-label": n,
        onClick: (o) => o.preventDefault(),
        className: "pf-v5-c-form__group-label-help",
        children: /* @__PURE__ */ t(
          _e,
          {
            isInline: r,
            status: l ? "warning" : void 0,
            children: /* @__PURE__ */ t(s, {})
          }
        )
      }
    ),
    a && /* @__PURE__ */ t(
      _e,
      {
        isInline: r,
        status: l ? "warning" : void 0,
        children: /* @__PURE__ */ t(s, {})
      }
    )
  ] }) }) : null;
};
function de(e) {
  if (!(typeof e > "u" || e instanceof RegExp))
    return typeof e == "object" ? e.value : e;
}
const Q = ({
  id: e,
  name: n,
  label: r,
  labelIcon: a,
  error: l,
  children: i,
  ...s
}) => /* @__PURE__ */ I(
  It,
  {
    label: r || n,
    fieldId: e || n,
    labelIcon: a ? /* @__PURE__ */ t($t, { helpText: a, fieldLabelId: e || n }) : void 0,
    ...s,
    children: [
      i,
      l && /* @__PURE__ */ t(qt, { "data-testid": `${n}-helper`, message: l.message })
    ]
  }
), Wa = ({
  name: e,
  label: n,
  controller: r,
  labelIcon: a,
  ...l
}) => {
  const {
    control: i,
    formState: { errors: s }
  } = Re();
  return /* @__PURE__ */ t(
    Q,
    {
      name: e,
      label: n,
      isRequired: r.rules?.required === !0,
      error: s[e],
      labelIcon: a,
      children: /* @__PURE__ */ t(
        ce,
        {
          ...r,
          name: e,
          control: i,
          render: ({ field: o }) => {
            const h = !!r.rules?.required, c = de(r.rules?.min), u = o.value ?? r.defaultValue, d = (g) => o.onChange(
              c !== void 0 ? Math.max(g, Number(c)) : g
            );
            return /* @__PURE__ */ t(
              cn,
              {
                ...l,
                id: e,
                value: u,
                validated: s[e] ? j.error : j.default,
                required: h,
                min: Number(c),
                max: Number(r.rules?.max),
                onPlus: () => d(u + 1),
                onMinus: () => d(u - 1),
                onChange: (g) => {
                  const y = Number(g.currentTarget.value);
                  d(isNaN(y) ? r.defaultValue : y);
                }
              }
            );
          }
        }
      )
    }
  );
}, $r = ({
  hasReveal: e = !0,
  innerRef: n,
  ...r
}) => {
  const { t: a } = $(), [l, i] = A(!0);
  return /* @__PURE__ */ I(xe, { children: [
    /* @__PURE__ */ t(qe, { isFill: !0, children: /* @__PURE__ */ t(
      Te,
      {
        ...r,
        type: l ? "password" : "text",
        ref: n
      }
    ) }),
    e && /* @__PURE__ */ t(
      B,
      {
        variant: "control",
        "aria-label": a("showPassword"),
        onClick: () => i(!l),
        children: l ? /* @__PURE__ */ t(Wn, {}) : /* @__PURE__ */ t(zn, {})
      }
    )
  ] });
}, Ut = qn(
  (e, n) => /* @__PURE__ */ t($r, { ...e, innerRef: n })
);
Ut.displayName = "PasswordInput";
const za = (e) => {
  const { labelIcon: n, ...r } = e, a = !!de(e.rules?.required), l = e.defaultValue ?? "", { field: i, fieldState: s } = De({
    ...e,
    defaultValue: l
  });
  return /* @__PURE__ */ I(
    Q,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: a,
      error: s.error,
      children: [
        /* @__PURE__ */ t(
          Ut,
          {
            isRequired: a,
            id: e.name,
            "data-testid": e.name,
            validated: s.error ? j.error : j.default,
            isDisabled: e.isDisabled,
            ...r,
            ...i
          }
        ),
        e.helperText && /* @__PURE__ */ t(We, { children: /* @__PURE__ */ t(ze, { children: /* @__PURE__ */ t(Je, { children: e.helperText }) }) })
      ]
    }
  );
}, Ur = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: l = [],
  controller: i,
  labelIcon: s,
  isDisabled: o,
  isFullWidth: h = !0,
  onSelect: c,
  ...u
}) => {
  const {
    control: d,
    formState: { errors: g }
  } = Re(), [y, C] = A(!1), R = de(i.rules?.required) === !0;
  return /* @__PURE__ */ t(
    Q,
    {
      id: e,
      name: n,
      label: r,
      isRequired: R,
      error: q(g, n),
      labelIcon: s,
      children: /* @__PURE__ */ t(
        ce,
        {
          ...i,
          name: n,
          control: d,
          render: ({ field: { onChange: b, value: p } }) => /* @__PURE__ */ t(
            Ee,
            {
              ...u,
              variant: "default",
              onClick: () => C(!y),
              onOpenChange: () => C(!1),
              selected: re(a) ? a.filter(
                (v) => Array.isArray(p) ? p.includes(v.key) : p === v.key
              ).map((v) => v.value) : p,
              toggle: (v) => /* @__PURE__ */ t(
                se,
                {
                  id: e || n,
                  ref: v,
                  onClick: () => C(!y),
                  isExpanded: y,
                  isFullWidth: h,
                  status: q(g, n) ? Qe.danger : void 0,
                  "aria-label": r,
                  isDisabled: o,
                  children: re(a) ? a.find(
                    (k) => k.key === (Array.isArray(p) ? p[0] : p)
                  )?.value : p
                }
              ),
              onSelect: (v, k) => {
                const w = k?.toString(), f = Array.isArray(p) ? [w] : w;
                c ? c(f, b) : b(f), C(!1);
              },
              isOpen: y,
              children: /* @__PURE__ */ t(Ae, { "data-testid": `select-${n}`, children: [...a, ...l].map((v) => /* @__PURE__ */ t(
                Ye,
                {
                  value: ie(v),
                  description: !me(v) && "description" in v ? v.description : void 0,
                  children: me(v) ? v : v.value
                },
                ie(v)
              )) })
            }
          )
        }
      )
    }
  );
}, ne = (e) => me(e) ? e : e.value, Kr = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: l = [],
  controller: i,
  labelIcon: s,
  placeholderText: o,
  onFilter: h,
  variant: c,
  isFullWidth: u = !0,
  ...d
}) => {
  const {
    control: g,
    formState: { errors: y }
  } = Re(), [C, R] = A(!1), [b, p] = A(""), [v, k] = A(0), [w, f] = A([]), x = Y(), V = de(i.rules?.required) === !0, O = c === he.typeaheadMulti, D = U(
    () => [
      ...a.filter(
        (m) => !l.map((T) => ne(T)).includes(ne(m))
      ),
      ...l
    ],
    [l, a]
  ), G = D.filter(
    (m) => ne(m).toLowerCase().startsWith(b.toLowerCase())
  ), F = (m, T) => {
    T.value.includes(m) ? (T.onChange(T.value.filter((E) => E !== m)), re(a) && f(
      w.filter((E) => E.key !== m)
    )) : (T.onChange([...T.value, m]), re(D) && f([
      ...w,
      D.find((E) => E.key === m)
    ]));
  }, N = (m, T) => {
    const E = G[v];
    switch (R(!0), m.key) {
      case "Enter": {
        m.preventDefault(), p(O ? "" : ne(E)), F(ie(E), T), R(!1), k(0);
        break;
      }
      case "Tab":
      case "Escape": {
        R(!1), T.onChange(void 0);
        break;
      }
      case "Backspace": {
        c === he.typeahead && T.onChange("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        m.preventDefault();
        let L = 0;
        m.key === "ArrowUp" && (v === 0 ? L = a.length - 1 : L = v - 1), m.key === "ArrowDown" && (v === a.length - 1 ? L = 0 : L = v + 1), k(L);
        break;
      }
    }
  };
  return /* @__PURE__ */ t(
    Q,
    {
      id: e,
      name: n,
      label: r,
      isRequired: V,
      error: q(y, n),
      labelIcon: s,
      children: /* @__PURE__ */ t(
        ce,
        {
          ...i,
          name: n,
          control: g,
          render: ({ field: m }) => /* @__PURE__ */ t(
            Ee,
            {
              ...d,
              onOpenChange: () => R(!1),
              selected: re(D) ? D.filter(
                (T) => Array.isArray(m.value) ? m.value.includes(T.key) : m.value === T.key
              ).map((T) => T.value) : m.value,
              shouldFocusFirstItemOnOpen: !1,
              toggle: (T) => /* @__PURE__ */ t(
                se,
                {
                  ref: T,
                  id: e || n,
                  variant: "typeahead",
                  onClick: () => {
                    R(!C), x.current?.focus();
                  },
                  isExpanded: C,
                  isFullWidth: u,
                  status: q(y, n) ? Qe.danger : void 0,
                  children: /* @__PURE__ */ I(kt, { isPlain: !0, children: [
                    /* @__PURE__ */ t(
                      wt,
                      {
                        placeholder: o,
                        value: c === he.typeahead && m.value ? re(D) ? D.find(
                          (E) => E.key === (Array.isArray(m.value) ? m.value[0] : m.value)
                        )?.value : m.value : b,
                        onClick: () => R(!C),
                        onChange: (E, L) => {
                          p(L), h?.(L);
                        },
                        onKeyDown: (E) => N(E, m),
                        autoComplete: "off",
                        innerRef: x,
                        role: "combobox",
                        isExpanded: C,
                        "aria-controls": "select-typeahead-listbox",
                        children: c === he.typeaheadMulti && Array.isArray(m.value) && /* @__PURE__ */ t(Xe, { "aria-label": "Current selections", children: m.value.map(
                          (E, L) => /* @__PURE__ */ t(
                            Ze,
                            {
                              onClick: (_) => {
                                _.stopPropagation(), m.onChange(
                                  m.value.filter(
                                    (Z) => Z !== ie(E)
                                  )
                                );
                              },
                              children: re(D) ? [
                                ...D,
                                ...w
                              ].find((_) => E === _.key)?.value : ne(E)
                            },
                            L
                          )
                        ) })
                      }
                    ),
                    /* @__PURE__ */ t(St, { children: (!!b || m.value) && /* @__PURE__ */ t(
                      B,
                      {
                        variant: "plain",
                        onClick: () => {
                          p(""), m.onChange(O ? [] : ""), x?.current?.focus();
                        },
                        "aria-label": "Clear input value",
                        children: /* @__PURE__ */ t(Vt, { "aria-hidden": !0 })
                      }
                    ) })
                  ] })
                }
              ),
              onSelect: (T, E) => {
                T?.stopPropagation();
                const L = E?.toString();
                O && Array.isArray(m.value) ? (p(""), F(L || "", m)) : (m.onChange(Array.isArray(m.value) ? [L] : L), R(!1));
              },
              isOpen: C,
              children: /* @__PURE__ */ t(Ae, { children: G.map((T, E) => /* @__PURE__ */ t(
                Ye,
                {
                  value: ie(T),
                  isFocused: v === E,
                  isActive: m.value.includes(ne(T)),
                  description: !me(T) && "description" in T ? T.description : void 0,
                  children: ne(T)
                },
                ie(T)
              )) })
            }
          )
        }
      )
    }
  );
};
var he = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(he || {});
const re = (e) => typeof e[0] != "string", me = (e) => typeof e == "string", ie = (e) => me(e) ? e : e.key, Hr = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t(Ur, { ...n }) : /* @__PURE__ */ t(Kr, { ...n, variant: e }), Ke = (e) => e && typeof e == "string" ? e.includes("${") : !1, He = (e) => e.substring(2, e.length - 1), ae = (e, n, r, a) => {
  const l = n || r, i = Ke(l) ? He(l) : l, s = a ? `${a}.${i}` : i;
  return e(s || "");
}, je = (e, n) => ae(e, n.displayName, n.name), jr = ["username", "firstName", "lastName", "email"], Kt = (e) => e && jr.includes(e), X = (e) => `${Kt(e) ? "" : "attributes."}${e?.replaceAll(
  ".",
  "🍺"
)}`, Ja = (e) => e.replaceAll(".", "🍺"), Gr = (e) => e.replaceAll("🍺", ".");
function Ya(e, n, r) {
  (e.responseData.errors !== void 0 ? e.responseData.errors : [e.responseData]).forEach((a) => {
    const l = Object.assign(
      {},
      a.params?.map((i) => Ke(i) ? r(He(i)) : i)
    );
    n(X(a.field), {
      message: r(
        Ke(a.errorMessage) ? He(a.errorMessage) : a.errorMessage,
        {
          /* eslint-disable @typescript-eslint/no-misused-spread */
          ...l,
          defaultValue: a.errorMessage || a.field
        }
      ),
      type: "server"
    });
  });
}
function Oe({
  required: e
}) {
  return e;
}
function Qa(e) {
  if (typeof e != "object" || e === null || !("responseData" in e))
    return !1;
  const { responseData: n } = e;
  return ut(n) ? !0 : typeof n != "object" || n === null || !("errors" in n) || !Array.isArray(n.errors) ? !1 : n.errors.every(ut);
}
function ut(e) {
  return !(typeof e != "object" || e === null || !("field" in e) || typeof e.field != "string" || !("errorMessage" in e) || typeof e.errorMessage != "string");
}
const Xa = ({
  labelOn: e,
  stringify: n,
  defaultValue: r,
  labelIcon: a,
  ...l
}) => {
  const s = r ?? (n ? "false" : !1), { control: o } = Re();
  return /* @__PURE__ */ t(
    Q,
    {
      hasNoPaddingTop: !0,
      name: l.name,
      isRequired: l.rules?.required === !0,
      label: l.label,
      labelIcon: a,
      children: /* @__PURE__ */ t(
        ce,
        {
          control: o,
          name: l.name,
          defaultValue: s,
          render: ({ field: { onChange: h, value: c } }) => /* @__PURE__ */ t(
            dn,
            {
              ...l,
              id: l.name,
              "data-testid": Gr(l.name),
              label: e,
              "aria-label": l.label,
              isChecked: n ? c === "true" : c,
              onChange: (u, d) => {
                const g = n ? d.toString() : d;
                l.onChange?.(u, d), h(g);
              }
            }
          )
        }
      )
    }
  );
}, Za = (e) => {
  const n = !!e.rules?.required, r = e.defaultValue ?? "", { field: a, fieldState: l } = De({
    ...e,
    defaultValue: r
  });
  return /* @__PURE__ */ t(
    Q,
    {
      isRequired: n,
      label: e.label,
      labelIcon: e.labelIcon,
      name: e.name,
      error: l.error,
      children: /* @__PURE__ */ t(
        xt,
        {
          isRequired: n,
          id: e.name,
          "data-testid": e.name,
          validated: l.error ? j.error : j.default,
          isDisabled: e.isDisabled,
          ...e,
          ...a
        }
      )
    }
  );
}, el = (e) => {
  const { labelIcon: n, helperText: r, ...a } = e, l = !!de(e.rules?.required), i = e.defaultValue ?? "", { field: s, fieldState: o } = De({
    ...e,
    defaultValue: i
  });
  return /* @__PURE__ */ I(
    Q,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: l,
      error: o.error,
      children: [
        /* @__PURE__ */ t(
          Te,
          {
            isRequired: l,
            id: e.name,
            "data-testid": e["data-testid"] || e.name,
            validated: o.error ? j.error : j.default,
            isDisabled: e.isDisabled,
            ...a,
            ...s
          }
        ),
        r && /* @__PURE__ */ t(We, { children: /* @__PURE__ */ t(ze, { children: /* @__PURE__ */ t(Je, { children: r }) }) })
      ]
    }
  );
}, Wr = xt, tl = (e) => {
  const { labelIcon: n, ...r } = e, a = !!de(e.rules?.required), l = e.defaultValue ?? "", { t: i } = $(), [s, o] = A(""), { field: h, fieldState: c } = De({
    ...e,
    defaultValue: l
  });
  return /* @__PURE__ */ t(
    Q,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: a,
      error: c.error,
      children: /* @__PURE__ */ t(
        un,
        {
          isRequired: a,
          "data-testid": e["data-testid"] || e.name,
          filename: s,
          browseButtonText: i("browse"),
          validated: c.error ? j.error : j.default,
          hideDefaultPreview: !0,
          isDisabled: e.isDisabled,
          type: "text",
          onFileInputChange: (u, d) => {
            h.onChange(d), o(d.name);
          },
          onClearClick: () => {
            h.onChange(null), o("");
          },
          ...r,
          ...h
        }
      )
    }
  );
}, nl = ({ icon: e }) => {
  const n = zr(e);
  return /* @__PURE__ */ t(_e, { size: "lg", children: /* @__PURE__ */ t(n, { alt: e }) });
};
function zr(e) {
  switch (e) {
    case "github":
      return sr;
    case "facebook":
      return ir;
    case "gitlab":
      return lr;
    case "google":
      return ar;
    case "linkedin":
    case "linkedin-openid-connect":
      return rr;
    case "openshift-v4":
      return nr;
    case "stackoverflow":
      return tr;
    case "twitter":
      return er;
    case "microsoft":
      return Zn;
    case "bitbucket":
      return Xn;
    case "instagram":
      return Qn;
    case "paypal":
      return Yn;
    default:
      return Jn;
  }
}
const Jr = "_title_180i0_2", Yr = {
  title: Jr
}, Ht = ({
  id: e,
  title: n,
  headingLevel: r = "h1",
  size: a = "xl",
  ...l
}) => /* @__PURE__ */ t(
  hn,
  {
    headingLevel: r,
    size: a,
    className: Yr.title,
    id: e,
    tabIndex: 0,
    ...l,
    children: n
  }
), Qr = ({
  title: e,
  children: n,
  scrollId: r,
  className: a
}) => {
  const l = Dt();
  return /* @__PURE__ */ I(pn, { id: l, className: a, isFlat: !0, children: [
    /* @__PURE__ */ t(mn, { className: "kc-form-panel__header", children: /* @__PURE__ */ t(fn, { tabIndex: 0, children: /* @__PURE__ */ t(Ht, { id: r, title: e }) }) }),
    /* @__PURE__ */ t(gn, { className: "kc-form-panel__body", children: n })
  ] });
}, Xr = (e) => {
  const { title: n, children: r, scrollId: a, ...l } = e;
  return /* @__PURE__ */ t("section", { ...l, style: { marginTop: "var(--pf-v5-global--spacer--lg)" }, children: /* @__PURE__ */ I(W, { children: [
    /* @__PURE__ */ t(Ht, { id: a, title: n }),
    r
  ] }) });
}, Zr = "_panel_1cdve_1", ea = "_sticky_1cdve_5", ht = {
  panel: Zr,
  sticky: ea
}, ta = "kc-main-content-page-container", pt = (e) => e.replace(/\s+/g, "-"), na = ({
  label: e,
  sections: n,
  borders: r = !1,
  ...a
}) => {
  const l = U(
    () => n.filter(({ isHidden: i }) => !i),
    [n]
  );
  return /* @__PURE__ */ I(yn, { hasGutter: !0, ...a, children: [
    /* @__PURE__ */ t(ot, { md: 8, sm: 12, children: l.map(({ title: i, panel: s }) => {
      const o = pt(i.toLowerCase());
      return /* @__PURE__ */ t(Ot, { children: r ? /* @__PURE__ */ t(
        Qr,
        {
          scrollId: o,
          title: i,
          className: ht.panel,
          children: s
        }
      ) : /* @__PURE__ */ t(Xr, { scrollId: o, title: i, children: s }) }, i);
    }) }),
    /* @__PURE__ */ t(ot, { md: 4, sm: 12, order: { default: "-1", md: "1" }, children: /* @__PURE__ */ t(bn, { className: ht.sticky, children: /* @__PURE__ */ t(
      vn,
      {
        isVertical: !0,
        scrollableSelector: `#${ta}`,
        label: e,
        offset: 100,
        children: l.map(({ title: i }) => {
          const s = pt(i.toLowerCase());
          return /* @__PURE__ */ t(
            Cn,
            {
              onClick: () => {
                const o = document.getElementById(s);
                o && o.scrollIntoView({
                  behavior: "smooth",
                  block: "start"
                });
              },
              "data-testid": `jump-link-${s}`,
              children: i
            },
            i
          );
        })
      }
    ) }) })
  ] });
}, ra = (e, n, r) => (e.isValid || r) && (e.isDirty || n) && !e.isLoading && !e.isValidating && !e.isSubmitting, rl = ({
  formState: e,
  isDisabled: n = !1,
  allowInvalid: r = !1,
  allowNonDirty: a = !1,
  children: l,
  ...i
}) => /* @__PURE__ */ t(
  B,
  {
    variant: "primary",
    isDisabled: e && !ra(e, a, r) || n,
    ...i,
    type: "submit",
    children: l
  }
), aa = (e) => {
  try {
    return new Intl.DisplayNames([e], { type: "language" }).of(e);
  } catch {
    return e;
  }
}, la = ({
  t: e,
  form: n,
  supportedLocales: r,
  currentLocale: a
}) => {
  const l = U(
    () => r.map((i) => ({
      key: i,
      value: e(`locale_${i}`, aa(i) ?? i)
    })).sort((i, s) => i.value.localeCompare(s.value, a)),
    [r, a, e]
  );
  return l.length ? /* @__PURE__ */ t(mr, { ...n, children: /* @__PURE__ */ t(
    Hr,
    {
      "data-testid": "locale-select",
      name: "attributes.locale",
      label: e("selectALocale"),
      controller: { defaultValue: "" },
      options: [{ key: "", value: e("defaultLocale") }, ...l],
      variant: l.length >= 10 ? "typeahead" : "single"
    }
  ) }) : null;
}, fe = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  children: l
}) => {
  const i = ae(
    e,
    r.annotations?.inputHelperTextBefore
  ), {
    formState: { errors: s }
  } = n, o = a?.(r), h = q(s, X(r.name));
  return /* @__PURE__ */ I(
    It,
    {
      label: je(e, r) || "",
      fieldId: r.name,
      isRequired: Oe(r),
      labelIcon: i ? /* @__PURE__ */ t($t, { helpText: i, fieldLabelId: r.name }) : void 0,
      children: [
        o ? /* @__PURE__ */ I(xe, { children: [
          l,
          o
        ] }) : l,
        h && /* @__PURE__ */ t(
          qt,
          {
            "data-testid": `${r.name}-helper`,
            message: h.message
          }
        )
      ]
    },
    r.name
  );
}, ia = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  ...l
}) => /* @__PURE__ */ t(fe, { t: e, form: n, attribute: r, renderer: a, children: /* @__PURE__ */ t(
  sa,
  {
    t: e,
    form: n,
    "aria-label": je(e, r),
    name: X(r.name),
    defaultValue: [r.defaultValue || ""],
    addButtonLabel: e("addMultivaluedLabel", {
      fieldLabel: je(e, r)
    }),
    ...l
  }
) }), sa = ({
  t: e,
  name: n,
  inputType: r,
  form: a,
  addButtonLabel: l,
  isDisabled: i = !1,
  defaultValue: s,
  id: o,
  ...h
}) => {
  const { register: c, setValue: u, control: d } = a, g = fr({
    name: n,
    control: d,
    defaultValue: s || ""
  }), y = U(() => Array.isArray(g) && g.length !== 0 ? g : s || [""], [g]), C = (k) => {
    p([...y.slice(0, k), ...y.slice(k + 1)]);
  }, R = () => {
    p([...y, ""]);
  }, b = (k, w) => {
    p([...y.slice(0, k), w, ...y.slice(k + 1)]);
  }, p = (k) => {
    const w = k.flatMap((f) => f);
    u(n, w, {
      shouldDirty: !0
    });
  }, v = r.startsWith("html") ? r.substring(6) : "text";
  return oe(() => {
    c(n);
  }, [c]), /* @__PURE__ */ t("div", { id: o, children: y.map((k, w) => /* @__PURE__ */ I(Ot, { children: [
    /* @__PURE__ */ I(xe, { children: [
      /* @__PURE__ */ t(qe, { isFill: !0, children: /* @__PURE__ */ t(
        Te,
        {
          "data-testid": n + w,
          onChange: (f, x) => b(w, x),
          name: `${n}.${w}.value`,
          value: k,
          isDisabled: i,
          type: v,
          ...h
        }
      ) }),
      /* @__PURE__ */ t(qe, { children: /* @__PURE__ */ t(
        B,
        {
          "data-testid": "remove" + w,
          variant: we.link,
          onClick: () => C(w),
          tabIndex: -1,
          "aria-label": e("remove"),
          isDisabled: y.length === 1 || i,
          children: /* @__PURE__ */ t(or, {})
        }
      ) })
    ] }),
    w === y.length - 1 && /* @__PURE__ */ I(
      B,
      {
        variant: we.link,
        onClick: R,
        tabIndex: -1,
        "aria-label": e("add"),
        "data-testid": "addValue",
        isDisabled: !k || i,
        children: [
          /* @__PURE__ */ t(Mt, {}),
          " ",
          e(l || "add")
        ]
      }
    )
  ] }, w)) });
}, mt = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = Oe(a), i = r.startsWith("multiselect"), s = i ? In : kn, o = a.validators?.options?.options || [], h = a.annotations?.inputOptionLabels || {}, c = a.annotations?.inputOptionLabelsI18nPrefix;
  return /* @__PURE__ */ t(fe, { ...e, children: /* @__PURE__ */ t(
    ce,
    {
      name: X(a.name),
      control: n.control,
      defaultValue: a.defaultValue,
      render: ({ field: u }) => /* @__PURE__ */ t(W, { children: o.map((d) => /* @__PURE__ */ t(
        s,
        {
          id: d,
          "data-testid": d,
          label: ae(e.t, h[d], d, c),
          value: d,
          isChecked: u.value?.includes(d),
          onChange: () => {
            i ? u.value?.includes(d) ? u.onChange(
              u.value?.filter((g) => g !== d)
            ) : u.onChange([...u.value || [], d]) : u.onChange([d]);
          },
          readOnly: a.readOnly,
          isRequired: l
        },
        d
      )) })
    }
  ) });
}, oa = ({
  toggleId: e,
  onToggle: n,
  onSelect: r,
  selections: a,
  isOpen: l,
  menuAppendTo: i,
  direction: s,
  width: o,
  maxHeight: h,
  toggleIcon: c,
  className: u,
  isDisabled: d,
  children: g,
  ...y
}) => {
  const [C, R] = A(!1), b = Y(), p = () => {
    R(!C), n(!C);
  }, v = () => i === "parent" && b.current?.parentElement || "inline", k = Ft.toArray(
    g
  );
  return /* @__PURE__ */ t(
    Ee,
    {
      ref: b,
      maxMenuHeight: Se(h),
      isScrollable: !0,
      popperProps: {
        appendTo: v(),
        direction: s,
        width: Se(o)
      },
      ...y,
      onClick: p,
      onOpenChange: (w) => {
        w !== C && p();
      },
      selected: a,
      onSelect: (w, f) => {
        r?.(f || ""), p();
      },
      toggle: (w) => /* @__PURE__ */ t(
        se,
        {
          id: e,
          ref: w,
          className: u,
          onClick: p,
          isExpanded: l,
          "aria-label": y["aria-label"],
          icon: c,
          isDisabled: d,
          isFullWidth: !0,
          children: k.find((f) => f.props.value === a)?.props.children || a || y["aria-label"]
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(Ae, { children: g })
    }
  );
}, ca = ({
  toggleId: e,
  onSelect: n,
  onToggle: r,
  onFilter: a,
  variant: l,
  validated: i,
  placeholderText: s,
  maxHeight: o,
  width: h,
  toggleIcon: c,
  direction: u,
  selections: d,
  typeAheadAriaLabel: g,
  chipGroupComponent: y,
  chipGroupProps: C,
  footer: R,
  isDisabled: b,
  children: p,
  ...v
}) => {
  const [k, w] = A(""), [f, x] = A(0), V = Y(), O = Ft.toArray(
    p
  ), D = () => {
    r?.(!v.isOpen);
  }, G = (F) => {
    const N = O[f];
    switch (r?.(!0), F.key) {
      case "Enter": {
        F.preventDefault(), l !== J.typeaheadMulti ? w(N.props.value) : w(""), n?.(N.props.value), r?.(!1), x(0);
        break;
      }
      case "Escape": {
        F.stopPropagation(), r?.(!1);
        break;
      }
      case "Backspace": {
        l === J.typeahead && n?.("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        F.preventDefault();
        let m = 0;
        F.key === "ArrowUp" && (f === 0 ? m = O.length - 1 : m = f - 1), F.key === "ArrowDown" && (f === O.length - 1 ? m = 0 : m = f + 1), x(m);
        break;
      }
    }
  };
  return /* @__PURE__ */ I(
    Ee,
    {
      ...v,
      onClick: D,
      onOpenChange: (F) => r?.(F),
      onSelect: (F, N) => {
        n?.(N || ""), a?.(""), w("");
      },
      maxMenuHeight: Se(o),
      popperProps: { direction: u, width: Se(h) },
      toggle: (F) => /* @__PURE__ */ t(
        se,
        {
          ref: F,
          id: e,
          variant: "typeahead",
          onClick: () => r?.(!0),
          icon: c,
          isDisabled: b,
          isExpanded: v.isOpen,
          isFullWidth: !0,
          status: i === "error" ? Qe.danger : void 0,
          children: /* @__PURE__ */ I(kt, { isPlain: !0, children: [
            /* @__PURE__ */ t(
              wt,
              {
                placeholder: s,
                value: l === J.typeahead && d ? d : k,
                onClick: D,
                onChange: (N, m) => {
                  w(m), a?.(m);
                },
                onKeyDown: (N) => G(N),
                autoComplete: "off",
                innerRef: V,
                role: "combobox",
                isExpanded: v.isOpen,
                "aria-controls": "select-typeahead-listbox",
                "aria-label": g,
                children: l === J.typeaheadMulti && Array.isArray(d) && (y || /* @__PURE__ */ t(Xe, { ...C, children: d.map((N, m) => /* @__PURE__ */ t(
                  Ze,
                  {
                    onClick: (T) => {
                      T.stopPropagation(), n?.(N);
                    },
                    children: N
                  },
                  m
                )) }))
              }
            ),
            /* @__PURE__ */ t(St, { children: !!k && /* @__PURE__ */ t(
              B,
              {
                variant: "plain",
                onClick: () => {
                  n?.(""), w(""), a?.(""), V?.current?.focus();
                },
                "aria-label": "Clear input value",
                children: /* @__PURE__ */ t(Vt, { "aria-hidden": !0 })
              }
            ) })
          ] })
        }
      ),
      children: [
        /* @__PURE__ */ t(Ae, { children: p }),
        R && /* @__PURE__ */ t(wn, { children: R })
      ]
    }
  );
};
var J = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(J || {});
const Se = (e) => typeof e == "number" ? e + "px" : e, da = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t(oa, { ...n }) : /* @__PURE__ */ t(ca, { ...n, variant: e }), ft = (e) => {
  const { t: n, form: r, inputType: a, attribute: l } = e, [i, s] = A(!1), [o, h] = A(""), c = a === "multiselect", u = (b, p) => {
    c ? p.value?.includes(b) ? p.onChange(p.value.filter((v) => v !== b)) : Array.isArray(p.value) ? p.onChange([...p.value, b]) : p.onChange([b]) : p.onChange(b === p.value ? "" : b);
  }, d = l.validators?.options?.options || [], g = l.annotations?.inputOptionLabels || {}, y = l.annotations?.inputOptionLabelsI18nPrefix, C = (b) => ae(e.t, g[b], b, y), R = (b) => d.filter(
    (p) => C(p).toLowerCase().includes(o.toLowerCase())
  ).map((p) => /* @__PURE__ */ t(
    Ye,
    {
      selected: Array.isArray(b) ? b.includes(p) : b === p,
      value: p,
      children: C(p)
    },
    p
  ));
  return /* @__PURE__ */ t(fe, { ...e, children: /* @__PURE__ */ t(
    ce,
    {
      name: X(l.name),
      defaultValue: l.defaultValue,
      control: r.control,
      render: ({ field: b }) => /* @__PURE__ */ t(
        da,
        {
          toggleId: l.name,
          onToggle: (p) => s(p),
          onClear: () => u("", b),
          onSelect: (p) => {
            const v = p.toString();
            u(v, b), Array.isArray(b.value) || s(!1);
          },
          selections: c && Array.isArray(b.value) ? b.value.map((p) => C(p)) : C(b.value),
          variant: c ? J.typeaheadMulti : d.length >= 10 ? J.typeahead : J.single,
          "aria-label": n("selectOne"),
          isOpen: i,
          isDisabled: l.readOnly,
          onFilter: (p) => (h(p), R(b.value)),
          children: R(b.value)
        }
      )
    }
  ) });
}, ua = (e) => {
  const { form: n, attribute: r } = e, a = Oe(r);
  return /* @__PURE__ */ t(fe, { ...e, children: /* @__PURE__ */ t(
    Wr,
    {
      id: r.name,
      "data-testid": r.name,
      ...n.register(X(r.name)),
      cols: r.annotations?.inputTypeCols,
      rows: r.annotations?.inputTypeRows,
      readOnly: r.readOnly,
      isRequired: a,
      defaultValue: r.defaultValue
    }
  ) });
}, K = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = Oe(a), i = r.startsWith("html") ? r.substring(6) : "text";
  return /* @__PURE__ */ t(fe, { ...e, children: /* @__PURE__ */ t(
    Te,
    {
      id: a.name,
      "data-testid": a.name,
      type: i,
      placeholder: a.readOnly ? "" : ae(
        e.t,
        a.annotations?.inputTypePlaceholder,
        "",
        a.annotations?.inputOptionLabelsI18nPrefix
      ),
      isDisabled: a.readOnly,
      isRequired: l,
      defaultValue: a.defaultValue,
      ...n.register(X(a.name))
    }
  ) });
}, Ge = {
  text: K,
  textarea: ua,
  select: ft,
  "select-radiobuttons": mt,
  multiselect: ft,
  "multiselect-checkboxes": mt,
  "html5-email": K,
  "html5-tel": K,
  "html5-url": K,
  "html5-number": K,
  "html5-range": K,
  "html5-datetime-local": K,
  "html5-date": K,
  "html5-month": K,
  "html5-time": K,
  "multi-input": ia
}, al = ({
  t: e,
  form: n,
  userProfileMetadata: r,
  supportedLocales: a,
  currentLocale: l,
  hideReadOnly: i = !1,
  renderer: s
}) => {
  const o = U(() => {
    if (!r.attributes)
      return [];
    const h = i ? r.attributes.filter(({ readOnly: c }) => !c) : r.attributes;
    return [
      // Insert an empty group for attributes without a group.
      { name: void 0 },
      ...r.groups ?? []
    ].map((c) => ({
      group: c,
      attributes: h.filter(
        (u) => u.group === c.name
      )
    }));
  }, [
    i,
    r.groups,
    r.attributes
  ]);
  return o.length === 0 ? null : /* @__PURE__ */ t(
    na,
    {
      label: e("jumpToSection"),
      sections: o.filter((h) => h.attributes.length > 0).map(({ group: h, attributes: c }) => ({
        title: ae(e, h.displayHeader, h.name) || e("general"),
        panel: /* @__PURE__ */ I("div", { className: "pf-v5-c-form", children: [
          h.displayDescription && /* @__PURE__ */ t(Ie, { className: "pf-v5-u-pb-lg", children: ae(e, h.displayDescription, "") }),
          c.map((u) => /* @__PURE__ */ t(
            ha,
            {
              t: e,
              form: n,
              supportedLocales: a,
              currentLocale: l,
              renderer: s,
              attribute: u
            },
            u.name
          ))
        ] })
      }))
    }
  );
}, ha = ({
  t: e,
  form: n,
  renderer: r,
  supportedLocales: a,
  currentLocale: l,
  attribute: i
}) => {
  const s = n.watch(
    X(i.name)
  ), o = U(() => ma(i), [i]), h = i.multivalued || ga(s) && i.annotations?.inputType === void 0 ? Ge["multi-input"] : Ge[o];
  return i.name === "locale" ? /* @__PURE__ */ t(
    la,
    {
      form: n,
      supportedLocales: a,
      currentLocale: l,
      t: e,
      attribute: i
    }
  ) : /* @__PURE__ */ t(
    h,
    {
      t: e,
      form: n,
      inputType: o,
      attribute: i,
      renderer: r
    }
  );
}, pa = "text";
function ma(e) {
  if (Kt(e.name))
    return "text";
  const n = e.annotations?.inputType;
  return fa(n) ? n : pa;
}
const fa = (e) => typeof e == "string" && e in Ge, ga = (e) => Array.isArray(e) && e.length > 1, ya = ({
  className: e = "",
  border: n,
  size: r = "md"
}) => /* @__PURE__ */ I(
  "svg",
  {
    className: br(
      ve.avatar,
      ve.modifiers[r],
      n === "light" && ve.modifiers.light,
      n === "dark" && ve.modifiers.dark,
      e
    ),
    enableBackground: "new 0 0 36 36",
    version: "1.1",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "circle",
        {
          style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
          cx: "18",
          cy: "18.5",
          r: "18"
        }
      ),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t(
        "filter",
        {
          id: "b",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          filterUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("feColorMatrix", { values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" })
        }
      ) }),
      /* @__PURE__ */ t(
        "mask",
        {
          id: "a",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          maskUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("g", { style: { filter: 'url("#b")' }, children: /* @__PURE__ */ t(
            "circle",
            {
              style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
              cx: "18",
              cy: "18.5",
              r: "18"
            }
          ) })
        }
      ),
      /* @__PURE__ */ t("g", { style: { filter: 'url("#a")' }, children: /* @__PURE__ */ I("g", { transform: "translate(5.04 6.88)", children: [
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m22.6 18.1c-1.1-1.4-2.3-2.2-3.5-2.6s-1.8-0.6-6.3-0.6-6.1 0.7-6.1 0.7 0 0 0 0c-1.2 0.4-2.4 1.2-3.4 2.6-2.3 2.8-3.2 12.3-3.2 14.8 0 3.2 0.4 12.3 0.6 15.4 0 0-0.4 5.5 4 5.5l-0.3-6.3-0.4-3.5 0.2-0.9c0.9 0.4 3.6 1.2 8.6 1.2 5.3 0 8-0.9 8.8-1.3l0.2 1-0.2 3.6-0.3 6.3c3 0.1 3.7-3 3.8-4.4s0.6-12.6 0.6-16.5c0.1-2.6-0.8-12.1-3.1-15z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m22.5 26c-0.1-2.1-1.5-2.8-4.8-2.8l2.2 9.6s1.8-1.7 3-1.8c0 0-0.4-4.6-0.4-5z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m12.7 13.2c-3.5 0-6.4-2.9-6.4-6.4s2.9-6.4 6.4-6.4 6.4 2.9 6.4 6.4-2.8 6.4-6.4 6.4z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.08,
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#231F20"
            },
            d: "m9.4 6.8c0-3 2.1-5.5 4.9-6.3-0.5-0.1-1-0.2-1.6-0.2-3.5 0-6.4 2.9-6.4 6.4s2.9 6.4 6.4 6.4c0.6 0 1.1-0.1 1.6-0.2-2.8-0.6-4.9-3.1-4.9-6.1z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m8.3 22.4c-2 0.4-2.9 1.4-3.1 3.5l-0.6 18.6s1.7 0.7 3.6 0.9l0.1-23z"
          }
        )
      ] }) })
    ]
  }
), gt = ({
  isKebab: e = !1,
  title: n,
  dropDownItems: r,
  ...a
}) => {
  const [l, i] = A(!1);
  return /* @__PURE__ */ t(
    Tt,
    {
      ...a,
      popperProps: {
        position: "right"
      },
      onOpenChange: (s) => i(s),
      toggle: (s) => /* @__PURE__ */ t(
        se,
        {
          "data-testid": `${a["data-testid"]}-toggle`,
          ref: s,
          onClick: () => i(!l),
          isExpanded: l,
          variant: e ? "plain" : "default",
          children: e ? /* @__PURE__ */ t(cr, {}) : n
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(Et, { children: r })
    }
  );
};
function ba(e, n) {
  if (!e)
    return n("unknownUser");
  const r = e.given_name, a = e.family_name, l = e.preferred_username;
  return r && a ? n("fullName", { givenName: r, familyName: a }) : r || a || l || n("unknownUser");
}
const ll = ({
  keycloak: e,
  brand: { src: n, alt: r, className: a, ...l },
  avatar: i,
  features: {
    hasLogout: s = !0,
    hasManageAccount: o = !0,
    hasUsername: h = !0
  } = {},
  kebabDropdownItems: c,
  dropdownItems: u = [],
  toolbarItems: d,
  toolbar: g,
  ...y
}) => {
  const { t: C } = $(), [R, b] = A(!1), p = [];
  o && p.push(
    /* @__PURE__ */ t(
      Me,
      {
        onClick: () => e.accountManagement(),
        children: C("manageAccount")
      },
      "manageAccount"
    )
  ), s && p.push(
    /* @__PURE__ */ t(Me, { onClick: () => e.logout(), children: C("signOut") }, "signOut")
  );
  const v = e.idTokenParsed?.picture;
  return /* @__PURE__ */ I(Sn, { ...y, children: [
    /* @__PURE__ */ t(xn, { children: /* @__PURE__ */ t(Tn, { variant: "plain", "aria-label": C("navigation"), children: /* @__PURE__ */ t(dr, {}) }) }),
    /* @__PURE__ */ t(En, { ...l, children: /* @__PURE__ */ t("img", { src: n, alt: r, className: a }) }),
    /* @__PURE__ */ I(An, { children: [
      g,
      /* @__PURE__ */ t(ke, { children: /* @__PURE__ */ I($e, { children: [
        d?.map((k, w) => /* @__PURE__ */ t(H, { align: { default: "alignRight" }, children: k }, w)),
        /* @__PURE__ */ t(H, { children: /* @__PURE__ */ t(
          Tt,
          {
            isOpen: R,
            onSelect: () => b(!1),
            onOpenChange: (k) => b(k),
            popperProps: {
              position: "start",
              enableFlip: !1,
              appendTo: () => {
                let k = document.querySelector(".siteSwitcherDropDown");
                return k || (k = document.createElement("div"), k.className = "siteSwitcherDropDown", document.body.appendChild(k)), k;
              }
            },
            toggle: (k) => /* @__PURE__ */ t(
              se,
              {
                ref: k,
                onClick: () => b(!R),
                variant: "plain",
                className: "pfe-navigation_secondary-link",
                children: /* @__PURE__ */ t(
                  B,
                  {
                    icon: /* @__PURE__ */ t(ur, {}),
                    variant: "plain"
                  }
                )
              }
            ),
            children: /* @__PURE__ */ t(
              Et,
              {
                className: "site-switcher-dropdown",
                style: {
                  margin: "0",
                  padding: "1rem",
                  boxSizing: "border-box",
                  zIndex: 9999
                },
                children: /* @__PURE__ */ t(Me, { style: { padding: "0" }, children: /* @__PURE__ */ t("site-switcher", { lang: "en" }) })
              }
            )
          }
        ) }),
        /* @__PURE__ */ t(
          H,
          {
            visibility: {
              default: "hidden",
              md: "visible"
            },
            children: /* @__PURE__ */ t(
              gt,
              {
                "data-testid": "options",
                dropDownItems: [...u, p],
                title: h ? ba(e.idTokenParsed, C) : void 0
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          H,
          {
            align: { default: "alignLeft" },
            visibility: {
              md: "hidden"
            },
            children: /* @__PURE__ */ t(
              gt,
              {
                "data-testid": "options-kebab",
                isKebab: !0,
                dropDownItems: [
                  ...c || u,
                  p
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          H,
          {
            variant: "overflow-menu",
            align: { default: "alignRight" },
            className: "pf-v5-u-m-0-on-lg",
            children: v || i?.src ? /* @__PURE__ */ t(Rn, { src: v, alt: C("avatar"), ...i }) : /* @__PURE__ */ t(ya, { ...i })
          }
        )
      ] }) })
    ] })
  ] });
}, jt = et("ErrorBoundaryContext", void 0), Gt = () => tt(jt);
class il extends $n {
  state = {};
  static getDerivedStateFromError = (n) => ({ error: n });
  showBoundary = (n) => {
    this.setState({ error: n });
  };
  render() {
    return /* @__PURE__ */ t(
      jt.Provider,
      {
        value: { error: this.state.error, showBoundary: this.showBoundary },
        children: this.props.children
      }
    );
  }
}
const sl = ({ children: e, fallback: n }) => {
  const { error: r } = Gt();
  return r ? /* @__PURE__ */ t(n, { error: r }) : e;
};
function va(e, n, r) {
  const { showBoundary: a } = Gt();
  oe(() => {
    const l = new AbortController(), { signal: i } = l;
    return e().then((s) => {
      i.aborted || n(s);
    }).catch((s) => {
      console.error(s), i.aborted || a(s);
    }), () => l.abort();
  }, r);
}
const Ca = () => {
  const { t: e } = $();
  return /* @__PURE__ */ t(Dn, { children: /* @__PURE__ */ t(Ct, { "aria-label": e("spinnerLoading") }) });
}, Ia = ({
  message: e,
  instructions: n,
  onPrimaryAction: r,
  hasIcon: a = !0,
  isSearchVariant: l,
  primaryActionText: i,
  secondaryActions: s,
  icon: o,
  isDisabled: h = !1,
  children: c
}) => /* @__PURE__ */ I(On, { "data-testid": "empty-state", variant: "lg", children: [
  a && l ? /* @__PURE__ */ t(ct, { icon: hr }) : a && /* @__PURE__ */ t(ct, { icon: o || Mt }),
  /* @__PURE__ */ t(Fn, { titleText: e, headingLevel: "h1" }),
  /* @__PURE__ */ t(Pn, { children: n }),
  /* @__PURE__ */ I(Vn, { children: [
    i && /* @__PURE__ */ t(
      B,
      {
        "data-testid": `${e.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: "primary",
        onClick: r,
        isDisabled: h,
        children: i
      }
    ),
    c,
    s && /* @__PURE__ */ t(Mn, { children: s.map((u) => /* @__PURE__ */ t(
      B,
      {
        "data-testid": `${u.text.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: u.type || we.secondary,
        onClick: u.onClick,
        isDisabled: h,
        children: u.text
      },
      u.text
    )) })
  ] })
] }), ka = ({
  toolbarItem: e,
  subToolbar: n,
  toolbarItemFooter: r,
  children: a,
  searchTypeComponent: l,
  inputGroupName: i,
  inputGroupPlaceholder: s,
  inputGroupOnEnter: o
}) => {
  const { t: h } = $(), [c, u] = A(""), d = (y) => {
    u(y.trim()), o?.(y.trim());
  }, g = (y) => {
    y.key === "Enter" && d(c);
  };
  return /* @__PURE__ */ I(W, { children: [
    /* @__PURE__ */ t(ke, { "data-testid": "table-toolbar", children: /* @__PURE__ */ I($e, { children: [
      i && /* @__PURE__ */ t(H, { children: /* @__PURE__ */ I(xe, { "data-testid": i, children: [
        l,
        s && /* @__PURE__ */ t(
          Ln,
          {
            "data-testid": "table-search-input",
            placeholder: s,
            "aria-label": h("search"),
            value: c,
            onChange: (y, C) => {
              u(C);
            },
            onSearch: () => d(c),
            onKeyDown: g,
            onClear: () => d("")
          }
        )
      ] }) }),
      e
    ] }) }),
    n && /* @__PURE__ */ t(ke, { children: /* @__PURE__ */ t($e, { children: n }) }),
    /* @__PURE__ */ t(Nn, {}),
    a,
    /* @__PURE__ */ t(ke, { children: r })
  ] });
}, yt = ({
  id: e,
  variant: n = "top",
  count: r,
  first: a,
  max: l,
  onNextClick: i,
  onPreviousClick: s,
  onPerPageSelect: o
}) => {
  const { t: h } = $(), c = Math.round(a / l);
  return /* @__PURE__ */ t(
    Bn,
    {
      widgetId: e,
      titles: {
        paginationAriaLabel: `${h("pagination")} ${n} `
      },
      isCompact: !0,
      toggleTemplate: ({
        firstIndex: u,
        lastIndex: d
      }) => /* @__PURE__ */ I("b", { children: [
        u,
        " - ",
        d
      ] }),
      itemCount: r + c * l,
      page: c + 1,
      perPage: l,
      onNextClick: (u, d) => i((d - 1) * l),
      onPreviousClick: (u, d) => s((d - 1) * l),
      onPerPageSelect: (u, d, g) => o(g - 1, d),
      variant: n
    }
  );
}, wa = ({
  count: e,
  searchTypeComponent: n,
  toolbarItem: r,
  subToolbar: a,
  children: l,
  inputGroupName: i,
  inputGroupPlaceholder: s,
  inputGroupOnEnter: o,
  ...h
}) => /* @__PURE__ */ t(
  ka,
  {
    searchTypeComponent: n,
    toolbarItem: /* @__PURE__ */ I(W, { children: [
      r,
      /* @__PURE__ */ t(H, { variant: "pagination", children: /* @__PURE__ */ t(yt, { count: e, ...h }) })
    ] }),
    subToolbar: a,
    toolbarItemFooter: e !== 0 ? /* @__PURE__ */ t(H, { variant: "pagination", children: /* @__PURE__ */ t(yt, { count: e, variant: "bottom", ...h }) }) : null,
    inputGroupName: i,
    inputGroupPlaceholder: s,
    inputGroupOnEnter: o,
    children: l
  }
), Wt = (e) => !!e && e.title !== void 0, bt = ({
  row: e,
  index: n,
  actions: r,
  actionResolver: a
}) => {
  const l = r || a?.(e, {});
  return /* @__PURE__ */ I(W, { children: [
    e.cells.map((i, s) => /* @__PURE__ */ t(le, { children: Wt(i) ? i.title : i }, `cell-${s}`)),
    l && l.length > 0 && !e.disableActions && /* @__PURE__ */ t(le, { isActionCell: !0, children: /* @__PURE__ */ t(wr, { items: l, extraData: { rowIndex: n } }) })
  ] });
}, Sa = ({ row: e }) => e.cells.map((n, r) => /* @__PURE__ */ t("div", { children: Wt(n) ? n.title : n }, `cell-${r}`));
function xa({
  columns: e,
  rows: n,
  actions: r,
  actionResolver: a,
  ariaLabelKey: l,
  selected: i,
  onSelect: s,
  onCollapse: o,
  canSelectAll: h,
  canSelect: c,
  isNotCompact: u,
  isRadio: d,
  ...g
}) {
  const { t: y } = $(), [C, R] = A(i || []), [b, p] = A([]), v = U(
    () => gr(
      C,
      n.map((f) => f.data),
      "id"
    ),
    [C, n]
  );
  oe(() => {
    if (h) {
      const f = document.getElementsByName("check-all").item(0);
      if (f) {
        const x = f;
        x.indeterminate = v.length < n.length && v.length > 0;
      }
    }
  }, [C, h, n]);
  const k = (f) => {
    R(f), s?.(f);
  }, w = (f, x) => {
    if (d) {
      const V = x ? [n[f].data] : [];
      k(V);
    } else if (f === -1) {
      const V = v.map(
        (O) => q(O, "id")
      );
      k(
        x ? [...C, ...n.map((O) => O.data)] : C.filter(
          (O) => !V.includes(q(O, "id"))
        )
      );
    } else
      k(x ? [...C, n[f].data] : C.filter(
        (V) => q(V, "id") !== n[f].data.id
      ));
  };
  return /* @__PURE__ */ I(
    vr,
    {
      ...g,
      variant: u ? void 0 : Cr.compact,
      "aria-label": y(l),
      children: [
        /* @__PURE__ */ t(Ir, { children: /* @__PURE__ */ I(Ce, { children: [
          o && /* @__PURE__ */ t(Le, { screenReaderText: y("expandRow") }),
          h && /* @__PURE__ */ t(
            Le,
            {
              screenReaderText: y("selectAll"),
              select: d ? void 0 : {
                onSelect: (f, x) => {
                  w(-1, x);
                },
                isSelected: v.length === n.length
              }
            }
          ),
          e.map((f) => /* @__PURE__ */ t(
            Le,
            {
              screenReaderText: y("expandRow"),
              className: f.transforms?.[0]().className,
              children: y(f.displayKey || f.name)
            },
            f.displayKey || f.name
          ))
        ] }) }),
        o ? n.map((f, x) => /* @__PURE__ */ t(dt, { children: x % 2 === 0 ? /* @__PURE__ */ I(Ce, { children: [
          /* @__PURE__ */ t(
            le,
            {
              expand: n[x + 1].cells.length === 0 ? void 0 : {
                isExpanded: b[x] ?? !1,
                rowIndex: x,
                expandId: "expandable-row-",
                onToggle: (V, O, D) => {
                  o(D, O);
                  const G = [...b];
                  G[x] = D, p(G);
                }
              }
            }
          ),
          /* @__PURE__ */ t(
            bt,
            {
              row: f,
              index: x,
              actions: r,
              actionResolver: a
            }
          )
        ] }) : /* @__PURE__ */ I(Ce, { isExpanded: b[x - 1] ?? !1, children: [
          /* @__PURE__ */ t(le, {}),
          /* @__PURE__ */ t(le, { colSpan: e.length, children: /* @__PURE__ */ t(kr, { children: /* @__PURE__ */ t(Sa, { row: f }) }) })
        ] }) }, x)) : /* @__PURE__ */ t(dt, { children: n.map((f, x) => /* @__PURE__ */ I(Ce, { isExpanded: b[x], children: [
          c && /* @__PURE__ */ t(
            le,
            {
              select: {
                rowIndex: x,
                onSelect: (V, O, D) => {
                  w(D, O);
                },
                isSelected: !!C.find(
                  (V) => q(V, "id") === f.data.id
                ),
                variant: d ? "radio" : "checkbox",
                isDisabled: f.disableSelection
              }
            }
          ),
          /* @__PURE__ */ t(
            bt,
            {
              row: f,
              index: x,
              actions: r,
              actionResolver: a
            }
          )
        ] }, x)) })
      ]
    }
  );
}
function Ta({
  ariaLabelKey: e,
  searchPlaceholderKey: n,
  isPaginated: r = !1,
  onSelect: a,
  canSelectAll: l = !1,
  isNotCompact: i,
  isRadio: s,
  detailColumns: o,
  isRowDisabled: h,
  loader: c,
  columns: u,
  actions: d,
  actionResolver: g,
  searchTypeComponent: y,
  toolbarItem: C,
  subToolbar: R,
  emptyState: b,
  icon: p,
  isSearching: v = !1,
  ...k
}) {
  const { t: w } = $(), [f, x] = A([]), [V, O] = A(), [D, G] = A(), [F, N] = A(!1), [m, T] = Bt(
    localStorage,
    "pageSize",
    10
  ), [E, L] = A(m), [_, Z] = A(0), [z, Fe] = A(""), nt = Y(), [ge, zt] = A(0), rt = Y(), at = () => zt(ge + 1), Jt = Dt(), lt = (S, P) => S.map((M) => {
    if ("cellFormatters" in M) {
      const te = q(P, M.name);
      return M.cellFormatters?.reduce((ue, be) => be(ue), te);
    }
    if (M.cellRenderer) {
      const te = M.cellRenderer;
      return { title: /* @__PURE__ */ t(te, { ...P }) };
    }
    return q(P, M.name);
  }), it = (S) => {
    const P = (M) => o?.[0]?.enabled?.(M);
    return S.map((M, te) => {
      const ue = h ? h(M) : !1, be = [
        {
          data: M,
          disableSelection: ue,
          disableActions: ue,
          selected: !!f.find((en) => q(en, "id") === q(M, "id")),
          isOpen: P(M) ? !1 : void 0,
          cells: lt(u, M)
        }
      ];
      return o && be.push({
        parent: te * 2,
        cells: P(M) ? lt(o, M) : []
      }), be;
    }).flat();
  }, Pe = (S) => ["string", "number"].includes(typeof S) ? S.toString() : S instanceof Array ? S.map(Pe).join("") : typeof S == "object" ? Pe(
    Un(S.title) ? S.title.props : Object.values(S)
  ) : "", st = U(
    () => z === "" || r ? void 0 : it(D || []).filter(
      (S) => S.cells.some(
        (P) => P && Pe(P).toLowerCase().includes(z.toLowerCase())
      )
    ).slice(_, _ + E + 1),
    [z, _, E]
  );
  va(
    async () => {
      N(!0);
      const S = nt.current === "" && z !== "";
      return S && Z(0), nt.current = z, typeof c == "function" ? ge === rt.current && D ? D : await c(S ? 0 : _, E + 1, z) : c;
    },
    (S) => {
      rt.current = ge, r || (G(S), S.length > _ ? S = S.slice(_, _ + E + 1) : Z(0));
      const P = it(S);
      O(P), N(!1);
    },
    [
      ge,
      _,
      E,
      z,
      typeof c != "function" ? c : void 0
    ]
  );
  const Yt = () => d && yr(d).map((S, P) => (delete S.onRowClick, S.onClick = async (M, te) => {
    await d[P].onRowClick(
      (st || V)[te].data
    ) && (r || Fe(""), at());
  }, S)), Qt = (S, P) => {
    ee[P].isOpen = S, O([...ee]);
  }, ee = st || V, ye = !ee || ee.length === 0, Ve = z !== "" || v, Xt = o ? E * 2 : E, Zt = o ? (ee?.length || 0) / 2 : ee?.length || 0;
  return /* @__PURE__ */ I(W, { children: [
    (!ye || Ve) && /* @__PURE__ */ I(
      wa,
      {
        id: Jt,
        count: Zt,
        first: _,
        max: E,
        onNextClick: Z,
        onPreviousClick: Z,
        onPerPageSelect: (S, P) => {
          Z(S), L(P), T(P);
        },
        inputGroupName: n ? `${e}input` : void 0,
        inputGroupOnEnter: Fe,
        inputGroupPlaceholder: w(n || ""),
        searchTypeComponent: y,
        toolbarItem: /* @__PURE__ */ I(W, { children: [
          C,
          " ",
          /* @__PURE__ */ t(H, { variant: "separator" }),
          " ",
          /* @__PURE__ */ t(H, { children: /* @__PURE__ */ I(B, { variant: "link", onClick: at, "data-testid": "refresh", children: [
            /* @__PURE__ */ t(pr, {}),
            " ",
            w("refresh")
          ] }) })
        ] }),
        subToolbar: R,
        children: [
          !F && !ye && /* @__PURE__ */ t(
            xa,
            {
              ...k,
              canSelectAll: l,
              canSelect: !!a,
              selected: f,
              onSelect: (S) => {
                x(S), a?.(S);
              },
              onCollapse: o ? Qt : void 0,
              actions: Yt(),
              actionResolver: g,
              rows: ee.slice(0, Xt),
              columns: u,
              isNotCompact: i,
              isRadio: s,
              ariaLabelKey: e
            }
          ),
          !F && ye && Ve && /* @__PURE__ */ t(
            Ia,
            {
              hasIcon: !0,
              icon: p,
              isSearchVariant: !0,
              message: w("noSearchResults"),
              instructions: w("noSearchResultsInstructions"),
              secondaryActions: v ? [] : [
                {
                  text: w("clearAllFilters"),
                  onClick: () => Fe(""),
                  type: we.link
                }
              ]
            }
          )
        ]
      }
    ),
    F && /* @__PURE__ */ t(Ca, {}),
    !F && ye && !Ve && b
  ] });
}
const Ea = ({ link: e, organization: n }) => {
  const { t: r } = $();
  return /* @__PURE__ */ t(Sr, { wrapModifier: "truncate", children: /* @__PURE__ */ I(e, { organization: n, children: [
    n.name,
    !n.enabled && /* @__PURE__ */ t(
      _n,
      {
        isRead: !0,
        className: "pf-v5-u-ml-sm",
        children: r("disabled")
      },
      `${n.id}-disabled`
    )
  ] }) });
}, Aa = (e) => {
  const { t: n } = $();
  return /* @__PURE__ */ t(
    Xe,
    {
      numChips: 2,
      expandedText: n("hide"),
      collapsedText: n("showRemaining"),
      children: e.domains?.map((r) => {
        const a = typeof r == "string" ? r : r.name;
        return /* @__PURE__ */ t(Ze, { isReadOnly: !0, children: a }, a);
      })
    }
  );
}, ol = ({
  loader: e,
  toolbarItem: n,
  isPaginated: r = !1,
  isSearching: a = !1,
  searchPlaceholderKey: l,
  onSelect: i,
  onDelete: s,
  deleteLabel: o = "delete",
  link: h,
  children: c,
  actions: u
}) => {
  const { t: d } = $();
  return /* @__PURE__ */ t(
    Ta,
    {
      loader: e,
      isPaginated: r,
      isSearching: a,
      ariaLabelKey: "organizationList",
      searchPlaceholderKey: l,
      toolbarItem: n,
      onSelect: i,
      canSelectAll: i !== void 0,
      actions: [
        ...s ? [{ title: d(o), onRowClick: s }] : [],
        ...u ?? []
      ],
      columns: [
        {
          name: "name",
          displayKey: "name",
          cellRenderer: (g) => /* @__PURE__ */ t(Ea, { link: h, organization: g })
        },
        {
          name: "domains",
          displayKey: "domains",
          cellRenderer: Aa
        },
        {
          name: "description",
          displayKey: "description"
        },
        {
          name: "membershipType",
          displayKey: "membershipType"
        }
      ],
      emptyState: c
    }
  );
};
export {
  Vr as AlertProvider,
  Ga as ContinueCancelModal,
  sl as ErrorBoundaryFallback,
  il as ErrorBoundaryProvider,
  Mr as ErrorPage,
  tl as FileUploadControl,
  qt as FormErrorText,
  Qr as FormPanel,
  rl as FormSubmitButton,
  _r as Help,
  $t as HelpItem,
  nl as IconMapper,
  Ta as KeycloakDataTable,
  ll as KeycloakMasthead,
  Ha as KeycloakProvider,
  da as KeycloakSelect,
  Ca as KeycloakSpinner,
  Wr as KeycloakTextArea,
  Ia as ListEmptyState,
  Wa as NumberControl,
  ol as OrganizationTable,
  wa as PaginatingTableToolbar,
  za as PasswordControl,
  Ut as PasswordInput,
  na as ScrollForm,
  Hr as SelectControl,
  he as SelectVariant,
  Xa as SwitchControl,
  ka as TableToolbar,
  Za as TextAreaControl,
  el as TextControl,
  al as UserProfileFields,
  Ja as beerify,
  et as createNamedContext,
  Gr as debeerify,
  Rr as generateId,
  Er as getErrorDescription,
  Tr as getErrorMessage,
  ja as getInjectedEnvironment,
  Ar as getNetworkErrorDescription,
  Lt as getNetworkErrorMessage,
  Dr as isDefined,
  Qa as isUserProfileError,
  ae as label,
  ta as mainPageContentId,
  Ya as setUserProfileServerError,
  Ua as useAlerts,
  Ka as useEnvironment,
  Gt as useErrorBoundary,
  va as useFetch,
  Br as useHelp,
  tt as useRequiredContext,
  Or as useSetTimeout,
  Bt as useStoredState
};
//# sourceMappingURL=keycloak-ui-shared.js.map
